import { render, staticRenderFns } from "./WellElecControllLastRecordModal.vue?vue&type=template&id=07bca928&scoped=true"
import script from "./WellElecControllLastRecordModal.vue?vue&type=script&lang=js"
export * from "./WellElecControllLastRecordModal.vue?vue&type=script&lang=js"
import style0 from "./WellElecControllLastRecordModal.vue?vue&type=style&index=0&id=07bca928&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bca928",
  null
  
)

export default component.exports